export default __webpack_public_path__ + "static/media/MeerkatCh7.e5e9434e.svg";